import { World } from '../../services/sculkwire';
import { State as AppState } from '..';

export const selectOverworld = (state: AppState): World | undefined => {
  if (state.worlds && state.worlds.length) {
    return state.worlds[0];
  }
  return undefined;
};
